<template>
  <div>
    <q-dialog v-model="modal" persistent>
      <q-card class="text-brand-5 text-weight-bold">
        <q-card-section>
          <div class="text-h6">{{ termo.titulo }}</div>
        </q-card-section>

        <q-separator />

        <q-card-section style="max-height: 50vh" class="scroll">
          <p>
            {{ termo.descricao }}
          </p>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn
            icon="close"
            label="Recusar"
            color="negative"
            no-caps
            @click="recusarTermo()"
          />
          <q-btn
            icon="check_circle_outline"
            label="Aceitar"
            color="positive"
            no-caps
            @click="assinarTermo()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { onMounted, ref, inject } from "vue";
import { useQuasar } from "quasar";

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    let modal = ref(false);
    const termo = ref([]);
    const assinatura = ref();
    const keycloak = inject("keycloak");

    const detalharTermos = async () => {
      let resposta = await store.dispatch("termo/buscarTermoAtivo");
      termo.value = resposta.data.resultado.dados;
      modal.value = true;
    };

    const assinarTermo = async () => {
      try {
        await store.dispatch("termo/assinarTermo");
        verificaAssinatura();
      } catch (error) {
        console.log(error);
      }
    };

    const recusarTermo = async () => {
      quasar.notify({
        message: "Aceite os termos para usar as funcionalidades do sistema",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });

      setTimeout(() => {
        store.dispatch("autenticacao/logout");
        keycloak.logout({ redirectUri: window.location.origin });
      }, 2000);
    };

    const verificaAssinatura = async () => {
      let resposta = await store.dispatch("termo/buscarAssinaturaTermo");
      if (resposta.data.resultado.termo_assinado) {
        store.commit("termo/ACEITE_TERMO", {
          aceite: true,
        });
        modal.value = false;
      }
    };

    onMounted(detalharTermos);
    return {
      detalharTermos,
      modal,
      termo,
      assinarTermo,
      assinatura,
      recusarTermo,
    };
  },
};
</script>
